// extracted by mini-css-extract-plugin
module.exports = {"location":"styles_location__3mjZd","city":"styles_city__xDb0y","content":"styles_content__2B0hH"};